import { render, staticRenderFns } from "./CalendarEventRichArgument.vue?vue&type=template&id=001d3253&"
import script from "./CalendarEventRichArgument.vue?vue&type=script&lang=js&"
export * from "./CalendarEventRichArgument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports